"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Item = _interopRequireWildcard(require("../Item/Item"));

var _List = _interopRequireDefault(require("./List.style"));

var List = function List(_ref) {
  var uploads = _ref.uploads,
      onItemIconClick = _ref.onItemIconClick;
  return _react.default.createElement(_List.default, null, uploads.map(function (upload) {
    return _react.default.createElement(_Item.default, {
      key: upload.id,
      upload: upload,
      onClick: onItemIconClick
    });
  }));
};

List.propTypes = {
  uploads: _propTypes.default.arrayOf(_Item.uploadPropType).isRequired,
  onItemIconClick: _propTypes.default.func.isRequired
};
var _default = List;
exports.default = _default;